import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import yellow from '@material-ui/core/colors/yellow';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Dropzone from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import fileImg from '../images/file.svg';
import { CircularProgress } from '@material-ui/core';

const styles = (theme) => ({
    dropzone: {
        padding: 20,
        borderWidth: 2,
        borderRadius: 4,
        borderStyle: 'dashed',
        borderColor: grey[200],
        textAlign: 'center',
    },
    error: {
        borderColor: red[500],
    },
    errorMessage: {
        textAlign: 'center',
        color: red[500],
    },
    fileList: {
        marginBottom: theme.spacing(3),
    },
    fileImage: {
        width: 64,
        height: 64,
    },
    deleteIcon: {
        padding: 5,
    },
    fileName: {
        wordWrap: 'break-word',
    },
    highlight: {
        backgroundColor: lighten(yellow[500], 0.8),
    },
});

class FileUpload extends React.Component {
    handleDelete = (event, index) => {
        this.props.onDelete(index);

        event.stopPropagation();
        event.preventDefault();
    };

    render() {
        return (
            <div>
                <Dropzone onDrop={this.props.onUpload} disabled={this.props.disabled}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div
                            {...getRootProps({
                                className: classNames(
                                    this.props.classes.dropzone,
                                    {
                                        [this.props.classes.error]: this.props.errorMessage,
                                    },
                                    {
                                        [this.props.classes.highlight]: isDragActive,
                                    },
                                ),
                            })}
                        >
                            <input {...getInputProps()} />
                            {this.props.files && this.props.files.length > 0 && (
                                <Grid container spacing={8} className={this.props.classes.fileList}>
                                    {this.props.files.map((file, index) => (
                                        <Grid item key={index} xs={3}>
                                            <Badge
                                                badgeContent={
                                                    <IconButton
                                                        onClick={(event) => this.handleDelete(event, index)}
                                                        aria-label="Remove file"
                                                        className={this.props.classes.deleteIcon}
                                                    >
                                                        &times;
                                                    </IconButton>
                                                }
                                            >
                                                <img
                                                    src={fileImg}
                                                    alt={file.name}
                                                    className={this.props.classes.fileImage}
                                                />
                                            </Badge>
                                            <Typography variant="caption" className={this.props.classes.fileName}>
                                                {file.name}
                                            </Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                            {!this.props.isLoading && !this.props.smartUpload && (
                                <Typography color="textSecondary">
                                    {"Drag 'n' drop files here, or click to select files."}
                                </Typography>
                            )}
                            {!this.props.isLoading && !this.props.selectedFile?.name && this.props.smartUpload && (
                                <Typography color="textSecondary">
                                    {"Drag 'n' drop file here, or click to select file."}
                                </Typography>
                            )}
                            {this.props.isLoading && (
                                <div>
                                    <CircularProgress></CircularProgress>
                                </div>
                            )}
                            {this.props.selectedFile?.name && !this.props.isLoading && (
                                <div>
                                    <Badge
                                        badgeContent={
                                            <IconButton
                                                onClick={(event) => this.handleDelete(event, 0)}
                                                aria-label="Remove file"
                                                className={this.props.classes.deleteIcon}
                                            >
                                                &times;
                                            </IconButton>
                                        }
                                    >
                                        <img
                                            src={fileImg}
                                            alt={this.props.selectedFile.name}
                                            className={this.props.classes.fileImage}
                                        />
                                    </Badge>
                                    <Typography>{this.props.selectedFile.name}</Typography>
                                </div>
                            )}
                        </div>
                    )}
                </Dropzone>
                {this.props.errorMessage && (
                    <Typography className={this.props.classes.errorMessage}>{this.props.errorMessage}</Typography>
                )}
            </div>
        );
    }
}

export default withStyles(styles)(FileUpload);
